import Sortable from "sortablejs";

export default {
    name: "sortable",

    props: {
        tag: {
            type: String,
            default: 'ul'
        },

        model: {
            type: String
        }
    },

    data: () => ({
        sortable: null,
        order: [],
        userSorted: false
    }),

    watch: {
        order(newOrder, oldOrder) {
            if (oldOrder.length > 0) this.updateOrder(newOrder);
        }
    },

    methods: {
        setOrder() {
            this.order = this.sortable.toArray();
        },

        updateOrder(newOrder) {
            let vm = this;

            axios.patch(`/admin/ajax/${this.model}/order`, newOrder)
                .then(() => { if(this.userSorted) vm.$bus.$emit('toast', {message: vm.$t__('Order updated'), type: 'success'}) })
                .catch(() => { if(this.userSorted) vm.$bus.$emit('toast', {message: vm.$t__('Order failed, please try again later'), type: 'danger'}) });
        }
    },

    render(createElement) {
        return createElement(
            this.tag,
            { 'class': { sortable: true } },
            this.$slots.default
        );
    },

    mounted() {
        this.sortable = new Sortable(this.$el, {
            handle: '.dragger',
            filter: '.ignore-elements',
            preventOnFilter: false,
            forceFallback: true,

            onStart: () => {
                this.$el.classList.add('is-dragging');
            },

            onEnd: () => {
                this.$el.classList.remove('is-dragging');
            },

            onMove: (e) => {
                return (!e.related || !e.related.classList.contains('ignore-elements')) && !e.related.classList.contains('ignore-elements');
            },

            onSort: () => {
                this.userSorted = true;
                this.setOrder();
            }
        });

        this.setOrder();
    },

    updated() {
        this.setOrder();
    }
}
